interface Dummy {
  id: string;
  name: string;
}

export const DUMMY: Dummy[] = [
  { id: '1234', name: '山田太郎' },
  { id: '8888', name: 'あいうえお' }
] as const;
